<template>
    <div class="col-12">
        <h4 class="header-title m-t-0">
            <i class="fas fa-euro mr-1"/>
            {{ $t("CarrierDestinationPriceList.carrierDestinationPrices") }}
        </h4>
        <hr/>
        <v-client-table :data="carrierDestination.prices" :columns="table.columns" :options="table.options">
            <button :disabled="carrierDestination.carrierAreaId && !canEditIfDestinationHasArea"
                    @click="showCarrierDestinationPriceModal()" class="btn btn-primary pull-right"
                    slot="afterLimit">
                <i class="fa fa-plus-circle mr-1"/>
                {{ $t("CarrierDestinationPriceList.addCarrierDestinationPrice") }}
            </button>
            <BooleanIcon slot-scope="props" slot="enabledForApi" :boolean="props.row.enabledForApi"/>
            <span slot="minWeight" slot-scope="props">
                {{ props.row.minWeight }} g
            </span>
            <span slot="maxWeight" slot-scope="props">
                {{ props.row.maxWeight }} g
            </span>
            <span slot="pricePurchase" slot-scope="props">
                {{ props.row.pricePurchaseLabel(carrier, currencies) }}
            </span>
            <span slot="price" slot-scope="props">
                {{ props.row.priceLabel(carrier, currencies) }}
            </span>
            <div class="text-center" slot="actions" slot-scope="props">
                <button v-tooltip="$t('CarrierDestinationPriceList.edit')"
                        @click="showCarrierDestinationPriceModal(props.row)"
                        :disabled="carrierDestination.carrierAreaId && !canEditIfDestinationHasArea"
                        class="btn btn-warning btn-xs mr-1">
                    <i class="fa fa-edit"/>
                </button>
                <CarrierDestinationPriceDeleteButton :disabled="carrierDestination.carrierAreaId && !canEditIfDestinationHasArea"
                                                     :carrier-destination-price="props.row" :carrier-destination="carrierDestination"
                                                     v-tooltip="$t('CarrierDestinationPriceList.delete')"
                                                     @editCarrierArea="editCarrierArea"
                                                     @deleteCarrierDestinationPrice="deleteCarrierDestinationPrice"/>
            </div>
        </v-client-table>
        <CarrierDestinationPriceFormModal @addCarrierDestinationPrice="addCarrierDestinationPrice"
                                          @editCarrierDestinationPrice="editCarrierDestinationPrice"
                                          @editCarrierArea="editCarrierArea"
                                          :carrier-destination="carrierDestination" :carrier="carrier"
                                          ref="CarrierDestinationPriceFormModal"/>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import CarrierDestinationPriceFormModal from "./CarrierDestinationPriceFormModal/CarrierDestinationPriceFormModal";
import CarrierDestinationPriceDeleteButton from "./CarrierDestinationPriceDeleteButton";
import BooleanIcon from "@/components/shared/misc/BooleanIcon";

export default {
    name: "CarrierDestinationPriceList",
    components: {CarrierDestinationPriceDeleteButton, CarrierDestinationPriceFormModal, BooleanIcon},
    props: {
        carrier: {
            type: Object,
            required: true,
        },
        carrierDestination: {
            type: Object,
            required: true,
        },
        canEditIfDestinationHasArea: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            table: {
                columns: this.generateCarrierDestinationPriceListColumns(this.carrier),
                options: {
                    perPage: 10,
                    sortable: ["enabledForApi", "minWeight", "maxWeight", "minQuantity", "maxQuantity", "pricePurchase", "price"],
                    headings: {
                        enabledForApi: this.$t("CarrierDestinationPriceList.enabledForApi"),
                        minWeight: this.$t("CarrierDestinationPriceList.minWeight"),
                        maxWeight: this.$t("CarrierDestinationPriceList.maxWeight"),
                        minQuantity: this.$t("CarrierDestinationPriceList.minQuantity"),
                        maxQuantity: this.$t("CarrierDestinationPriceList.maxQuantity"),
                        price: this.$t("CarrierDestinationPriceList.price"),
                        pricePurchase: this.$t("CarrierDestinationPriceList.pricePurchase"),
                        actions: this.$t("CarrierDestinationPriceList.actions"),
                    },
                    orderBy: {
                        column: this.carrier.chargesBy === "weight" ? "minWeight": "minQuantity",
                    },
                },
            },
        };
    },
    computed: {
        ...mapGetters("currencies", {
            currencies: "currencies",
        }),
    },
    methods: {
        generateCarrierDestinationPriceListColumns(carrier) {
            if (carrier.chargesBy === "weight") {
                return ["enabledForApi", "minWeight", "maxWeight", "pricePurchase", "price", "actions"];
            } else if (carrier.chargesBy === "lot" || carrier.chargesBy === "quantity") {
                return ["enabledForApi", "minQuantity", "maxQuantity", "pricePurchase", "price", "actions"];
            }
            return [];
        },
        showCarrierDestinationPriceModal(carrierDestinationPrice = null) {
            this.$refs.CarrierDestinationPriceFormModal.show(carrierDestinationPrice);
        },
        addCarrierDestinationPrice(carrierDestinationPrice) {
            this.$emit("addCarrierDestinationPrice", carrierDestinationPrice);
        },
        editCarrierDestinationPrice(newCarrierDestinationPrice) {
            this.$emit("editCarrierDestinationPrice", newCarrierDestinationPrice);
        },
        deleteCarrierDestinationPrice(carrierDestinationPrice) {
            this.$emit("deleteCarrierDestinationPrice", carrierDestinationPrice);
        },
        editCarrierArea(carrierArea) {
            this.$emit("editCarrierArea", carrierArea);
        },
    },
};
</script>

<style scoped>

</style>